import { useEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Api } from '../../lib/api';
import { useTypes, qk } from '../../hooks/useVault';
import { useUi } from '../../store/ui';

export function NewNoteDialog({ folder, initialTitle = '', onClose }: { folder?: string | null; initialTitle?: string; onClose: () => void }) {
  const types = useTypes();
  const qc = useQueryClient();
  const ui = useUi();
  const [title, setTitle] = useState(initialTitle);
  const [type, setType] = useState('note');
  const [busy, setBusy] = useState(false);
  const input = useRef<HTMLInputElement>(null);
  useEffect(() => input.current?.focus(), []);

  const def = types.data?.find((t) => t.key === type);
  const targetFolder = folder ?? def?.folder ?? '00-Inbox';

  const submit = async () => {
    if (!title.trim() || busy) return;
    setBusy(true);
    try {
      const slug = title.trim().replace(/[\\/:*?"<>|#^[\]]+/g, ' ').replace(/\s+/g, '-').replace(/^-|-$/g, '');
      const path = folder !== undefined && folder !== null ? `${folder ? folder + '/' : ''}${slug}.md` : undefined;
      const n = await Api.notes.create({ title: title.trim(), type, path });
      qc.invalidateQueries({ queryKey: qk.tree });
      ui.openNote(n.id);
      ui.toast(`Created ${n.path}`);
      onClose();
    } catch (err) {
      ui.toast(`Could not create: ${(err as Error).message}`, 'crit');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="scrim" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="dialog panel ticks" role="dialog" aria-label="New note" onKeyDown={(e) => e.key === 'Escape' && onClose()}>
        <div className="dialog-head">New note</div>
        <div className="dialog-body">
          <label>
            Title
            <input ref={input} type="text" value={title} onChange={(e) => setTitle(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && void submit()} placeholder="South Walker Creek" />
          </label>
          <label>
            Type
            <select value={type} onChange={(e) => setType(e.target.value)}>
              {(types.data ?? []).map((t) => (
                <option key={t.key} value={t.key}>{t.label}</option>
              ))}
            </select>
          </label>
          <div className="mono" style={{ color: 'var(--text-faint)' }}>→ {targetFolder}/</div>
        </div>
        <div className="dialog-foot">
          <button onClick={onClose}>Cancel</button>
          <button className="primary" disabled={!title.trim() || busy} onClick={() => void submit()}>Create</button>
        </div>
      </div>
    </div>
  );
}
